import React from "react";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import {
  LiveTvTwoTone,
  SettingsOutlined,
  ChevronLeft,
  ChevronRightOutlined,
  HomeOutlined,
  ShoppingCartOutlined,
  Groups2Outlined,
  ReceiptLongOutlined,
  PublicOutlined,
  PointOfSaleOutlined,
  TodayOutlined,
  CalendarMonthOutlined,
  AdminPanelSettingsOutlined,
  TrendingUpOutlined,
  PieChartOutlined,
  MoneyOutlined,
  ExpandLess,
  ExpandMore,
  SportsEsportsOutlined,
  UploadFileOutlined,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FlexBetween from "./FlexBetween";
import profileImage from "../assets/profile.png";
import { themeSettings } from "../theme/theme";
import { useSelector } from "react-redux";

const navItems = {
  "Super Admin": [
    {
      text: "",
      label: "Dashboard",
      icon: <HomeOutlined />,
    },
    {
      text: "user-managment",
      label: "Admin User Managment",
      icon: <MoneyOutlined />,
    },
    {
      text: "client-user-managment",
      label: "Client User Managment",
      icon: <MoneyOutlined />,
    },
    {
      text: "user-transaction",
      label: "User Transactions",
      icon: <ReceiptLongOutlined />,
    },
    {
      text: "sales-dashboard",
      label: "Sales Dashboard",
      icon: <PointOfSaleOutlined />,
    },
    {
      text: "rapshorts",
      label: "Rapshorts",
      icon: <LiveTvTwoTone />,
    },
    {
      text: "rap-studio",
      label: "RapStudio",
      icon: <LiveTvTwoTone />,
    },
    {
      text: "feedback-forms",
      label: "Feedback Forms",
      icon: <ReceiptLongOutlined />,
    },
    {
      text: "questions",
      label: "Questions",
      icon: <Groups2Outlined />,
    },
    // {
    //   text: "list-contents",
    //   label: "Contents List",
    //   icon: <ReceiptLongOutlined />,
    // },
    {
      text: "entertainment-entity-management",
      label: "Entertainment Entity",
      icon: <SportsEsportsOutlined />,
    },
    {
      text: "fl-active-stats",
      label: "Rap League Active Stats",
      icon: <SportsEsportsOutlined />,
    },
    {
      text: "game-management",
      label: "Rap League Game",
      icon: <SportsEsportsOutlined />,
    },
    { 
      text: "rap-housie-managment",
      label: "Rap Housie Game",
      icon: <SportsEsportsOutlined />,
      children: [
        { label: "Housie Games", text: "rapgame" },
        { label: "Housie Multimedia", text: "rapmultimedia" }
      ]
    },
    {
      text: "upload-csv",
      label: "Upload CSV",
      icon: <UploadFileOutlined />,
    },
    {
      text: "upload-multimedia",
      label: "Upload Multimedia",
      icon: <UploadFileOutlined />,
    },
    // {
    //   text: "data-pipeline",
    //   label: "Data Pipeline",
    //   icon: <LiveTvTwoTone />,
    //   children: [
    //     { text: "tmdb", label: "TMDB" },
    //     { text: "omdb", label: "OMDB" },
    //     // { text: "otdb", label: "OTDB" },
    //     // { text: "imdb", label: "IMDB" },
    //     { text: "jio-saavan", label: "Jio Saavan" },
    //     { text: "spotify", label: "Spotify" },
    //     // { text: "music-branz", label: "Music Branz" },
    //   ],
    // },
  ],
  "Admin": [
    {
      text: "Dashboard",
      label: "Dashboard",
      icon: <HomeOutlined />,
    },
    {
      text: "viewers-analytics",
      label: "Viewers Analytics",
      icon: <MoneyOutlined />,
    },
    {
      text: "contents-approvals",
      label: "Contents Approvals",
      icon: <Groups2Outlined />,
    },
    {
      text: "list-contents",
      label: "Contents List",
      icon: <ReceiptLongOutlined />,
    },
    {
      text: "feedback-forms",
      label: "Feedback Forms",
      icon: <ReceiptLongOutlined />,
    },
  ],
  "Content Creator": [
    {
      text: "Dashboard",
      label: "Dashboard",
      icon: <HomeOutlined />,
    },
    {
      text: "add-content",
      label: "Add Contents",
      icon: <ReceiptLongOutlined />,
    },
    {
      text: "list-contents",
      label: "Contents List",
      icon: <ReceiptLongOutlined />,
    },
  ],
  "Content Reviewer": [
    {
      text: "Dashboard",
      label: "Dashboard",
      icon: <HomeOutlined />,
    },
    {
      text: "list-contents",
      label: "Contents List",
      icon: <ReceiptLongOutlined />,
    },
    {
      text: "list-approved-contents",
      label: "Approved Contents List",
      icon: <ReceiptLongOutlined />,
    },
    {
      text: "list-declined-contents",
      label: "Declined Contents List",
      icon: <ReceiptLongOutlined />,
    },
    {
      text: "list-reported-contents",
      label: "Reported Contents List",
      icon: <ReceiptLongOutlined />,
    },
  ],
};

const Sidebar = ({ user, isNonMobile, drawerWidth, isSidebarOpen, setIsSidebarOpen }) => {
  const { pathname } = useLocation();
  const [active, setActive] = useState("");
  const [openSubmenu, setOpenSubmenu] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const mode = useSelector((state) => state.global.mode);

  useEffect(() => {
    //console.log("pathname : ", pathname.substring(1));
    setActive(pathname.substring(1));
  }, [pathname]);

  const toggleSubmenu = (key) => {
    setOpenSubmenu((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <Box component={"nav"}>
      {
        <Drawer
          open={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
          variant="persistent"
          anchor="left"
          sx={{
            width: drawerWidth,
            "& .MuiDrawer-paper": {
              color: themeSettings(mode).palette.secondary[200],
              background: themeSettings(mode).palette.background.alt,
              boxSizing: "border-box",
              borderWidth: isNonMobile ? 0 : "2px",
              width: drawerWidth,
            },
          }}
        >
          <Box width={"100%"}>
            <Box m={"3rem 2rem 2rem 3rem"}>
              <FlexBetween color={themeSettings(mode).palette.secondary.main}>
                <Box display={"flex"} alignItems={"center"} gap={"0.5rem"}>
                  <Typography variant="h4" fontWeight={"bold"}>
                    RAPCHIK
                  </Typography>
                </Box>
                {!isNonMobile && (
                  <IconButton
                    onClick={() => {
                      setIsSidebarOpen(!isSidebarOpen);
                    }}
                  >
                    <ChevronLeft />
                  </IconButton>
                )}
              </FlexBetween>
            </Box>
            <List>
              {navItems[user?.["custom:role"]]?.map((item) => {
                const { text, label, icon, children } = item;
                const lcText = text?.toLowerCase();
                const isActive = active === lcText || active.startsWith(`${lcText}/`);
                const isOpen = openSubmenu[lcText];

                return (
                  <Box key={text}>
                    <ListItem disablePadding>
                      <ListItemButton
                        onClick={() => {
                          if (children) {
                            toggleSubmenu(lcText);
                          } else {
                            navigate(`/${lcText}`);
                            setActive(lcText);
                          }
                        }}
                        sx={{
                          alignItems: "center",
                          paddingLeft: "8px",
                          paddingRight: "8px",
                          gap: "8px",
                          backgroundColor:
                            isActive && !children
                              ? themeSettings(mode).palette.secondary[300]
                              : "transparent",
                          color:
                            isActive && !children
                              ? themeSettings(mode).palette.primary[600]
                              : themeSettings(mode).palette.secondary[100],
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: "unset",
                            margin: 0,
                            ml: "2rem",
                            color:
                              isActive && !children
                                ? themeSettings(mode).palette.primary[600]
                                : themeSettings(mode).palette.secondary[200],
                          }}
                        >
                          {icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={label}
                          sx={{
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        />
                        {children && (
                          <Box ml="auto" color={themeSettings(mode).palette.secondary[200]}>
                            {isOpen ? <ExpandLess /> : <ExpandMore />}
                          </Box>
                        )}
                      </ListItemButton>
                    </ListItem>

                    {/* Child items */}
                    {children && isOpen && (
                      <List component="div" disablePadding>
                        {children.map(({ text: childText, label: childLabel }) => {
                          const fullPath = `${lcText}/${childText}`;
                          const isChildActive = active === fullPath;
                          return (
                            <ListItem key={childText} disablePadding sx={{ ml: 3 }}>
                              <ListItemButton
                                sx={{
                                  pl: "3rem",
                                  backgroundColor: isChildActive
                                    ? themeSettings(mode).palette.secondary[300]
                                    : "transparent",
                                  color: isChildActive
                                    ? themeSettings(mode).palette.primary[600]
                                    : themeSettings(mode).palette.secondary[100],
                                }}
                                onClick={() => {
                                  if (lcText === 'rap-housie-managment') {
                                    navigate(`/${fullPath}`, { state: { data: { childLabel } } });
                                  }
                                  else {
                                    navigate(`/${lcText}`, { state: { data: { childLabel } } });
                                  }
                                  console.log("lcText : ", lcText);
                                  console.log("fullPath : ", fullPath);
                                  setActive(fullPath);
                                }}
                              >
                                <ListItemText primary={childLabel} />
                              </ListItemButton>
                            </ListItem>
                          );
                        })}
                      </List>
                    )}
                  </Box>
                );
              })}

            </List>
          </Box>

          {/* <Box position={"absolute"} bottom={"2rem"}>
            <Divider />
            <FlexBetween textTransform={"none"} gap={"1rem"} m={"1.5rem 2rem 0 3rem"}>
              <Box
              component={"img"}
              alt="profile"
              src={profileImage}
              height={"40px"}
              width={"40px"}
              borderRadius={"50%"}
              sx={{objectFit:"cover"}}
              />
                <Box textAlign={"left"}>
                  <Typography 
                  fontWeight={"bold"} 
                  fontSize={"0.9rem"}
                  sx={{color:themeSettings(mode).palette.secondary[100]}}
                  >
                    {user.name}
                  </Typography>
                  <Typography 
                  fontWeight={"bold"} 
                  fontSize={"0.8rem"}
                  sx={{color:themeSettings(mode).palette.secondary[200]}}
                  >
                    {user.occupation}
                  </Typography>
                </Box>
                <SettingsOutlined
                sx={{color:themeSettings(mode).palette.secondary[300], fontSize:"25px"}}
                />
            </FlexBetween>
          </Box> */}
        </Drawer>
      }
    </Box>
  );
};

export default Sidebar;
